import {Grid} from "@mui/material";
import Paper from "@mui/material/Paper";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import EnhancedTableToolbar from "../enhanced/EnhancedTableToolbar";
import {fetchUserProfileAsync} from "../../features/authSlice";

function Profile() {
  const dispatch = useDispatch();

  const profileInfo = useSelector((state) => state.auth.main);

  useEffect(() => {
    dispatch(fetchUserProfileAsync());
  }, [dispatch]);

  function getPhoneFormatted(phoneNumber) {
    const cleaned = ('' + phoneNumber).replace(/\D/g, ''); // Odstranění nečíselných znaků
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{3})$/);

    if (match) {
      return `+420 ${match[1]} ${match[2]} ${match[3]}`;
    }

    return phoneNumber;
  }

  return (Object.keys(profileInfo).length !== 0 ?
    <div>
      <Paper>
        <EnhancedTableToolbar label="Můj profil" />
        <Grid container spacing={1}  style={{padding: 20}}>
          <Grid item xs={12}>
            <b>Jméno</b>: {profileInfo.name}
          </Grid>
          <Grid item xs={12}>
            <b>Role</b>: {profileInfo.role}
          </Grid>
          <Grid item xs={12}>
            <b>Email</b>: {profileInfo.email}
          </Grid>
          <Grid item xs={12}>
            <b>Telefon</b>: {getPhoneFormatted(profileInfo.phone)}
          </Grid>
          <Grid item xs={12}>
            <hr />
          </Grid>
          {Object.entries(profileInfo.profileOptions?.options).map(([key, option]) => (
              option.value !== '' ? (
                  <Grid item xs={12} key={key}>
                    <b>{option.typeName}:</b> {option.value}
                  </Grid>
              ): null
          ))}
        </Grid>
      </Paper>
    </div> : null
  );
}
export default Profile;
